<script>
    import { onMount } from "svelte";
    import DateInput from "../../../Components/Common/DateInput.svelte";
    import { getEncounterPayments } from "../helpers/encounterHelper.svelte";
    import InvoiceReasonDetails from "./InvoiceReasonDetails.svelte";
    import PatientEncounterInvoiceClaimDelay from "./PatientEncounterInvoiceClaimDelay.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import { showInfo } from "../../../Utils/utilFunctions.svelte";

    export let 
        latestInvoiceData, 
        sendInvoice, 
        //sendWithDelay,
        //claimDelayProps,
        customDueDate,
        patientEncounterDetails;

    onMount(() => {
        if(latestInvoiceData.oopType == 1 && latestInvoiceData.actualGap > 0) {
            //only load default quote due date for prepay with gap
            getDefaultDueDate();
        }
    })

    const getDefaultDueDate = async () => {
        var invoiceDefaultDueDate = await apiMethods.getMethod.getInvoiceDueDateByBillingItem(latestInvoiceData.id);

        if(invoiceDefaultDueDate) {
            showInfo("Invoice default due date was preset")
            customDueDate = new Date(invoiceDefaultDueDate);
        }
    }

    const getDetails = () => {
        let details = [
            "Create invoice",
        ];
        if([0, 10, 11, 15, 20].includes(latestInvoiceData.patientInsuranceType)){
            //private, self insured, cosmetic, overseas, dva (only postpay)
            if(latestInvoiceData.oopType == 0){
                //prepay

                //patient pays = gap
                if(!latestInvoiceData.patientPaysTotalFee) {
                    details.push("Claim via ECLIPSE");
                    details.push("Change encounter status to IN PROGRESS");
                }
                //patient pays = total fee
                if(latestInvoiceData.patientPaysTotalFee){
                    const patientPayments = getEncounterPayments(patientEncounterDetails, [0, 1, 2], 0); //paid by patient, received or pending
                    var patientPaymentReceived = patientPayments.length > 0; 
                    if(patientPaymentReceived){
                        //patient payment received

                        //patient claim = false
                        if(!latestInvoiceData.patientClaim) {
                            if(latestInvoiceData.invoiceReason == 1 || latestInvoiceData.invoiceReason == 2) //record or payment due
                                details.push("Send patient final invoice and receipt");
                            else if (latestInvoiceData.invoiceReason == 3) //topup
                                details.push("Send patient topup invoice");
                            else if (latestInvoiceData.invoiceReason == 4) //refund
                                details.push("Send patient refund invoice");

                            details.push("Change encounter status to IN PROGRESS");
                        }

                        //patient claim = true
                        if(latestInvoiceData.patientClaim) {
                            details.push("Send invoice to ECLIPSE (Patient Claim Interactive)");
                            details.push("Change encounter status to COMPLETED");
                        }
                    } else {
                        //patient payment not received
                        
                        //patient claim = false
                        if(!latestInvoiceData.patientClaim) {
                            details.push("Await patient payment");
                            details.push("Change encounter status to IN PROGRESS");
                            details.push("Once paid, patient will be sent final invoice and receipt, and the encounter marked as COMPLETED");
                        }

                        //patient claim = true
                        if(latestInvoiceData.patientClaim) {
                            details.push("Await patient payment");
                            details.push("Change encounter status to IN PROGRESS");
                            details.push("Once paid, invoice will be sent via ECLIPSE (Patient Claim Interactive) and encounter marked as COMPLETED");
                        }
                    }
                }
            } else {
                //postpay

                //patient pays = gap & gap = 0
                if(!latestInvoiceData.patientPaysTotalFee && latestInvoiceData.actualGap == 0) {
                    details.push("Claim via ECLIPSE");
                    details.push("Change encounter status to IN PROGRESS");
                }
                //patient pays = gap & gap > 0
                if(!latestInvoiceData.patientPaysTotalFee && latestInvoiceData.actualGap > 0) {
                    details.push("Send patient payment link");
                    details.push("Claim via ECLIPSE");
                    details.push("Change encounter status to IN PROGRESS");
                }
                //patient pays = total fee & patient claim = false
                if(latestInvoiceData.patientPaysTotalFee && !latestInvoiceData.patientClaim) {
                    details.push("Send patient payment link");
                    details.push("Change encounter status to IN PROGRESS");
                    details.push("Once fully paid, final invoice and receipt will be sent to patient and encounter marked as COMPLETED");

                }
                //patient pays = total fee & patient claim = true
                if(latestInvoiceData.patientPaysTotalFee && latestInvoiceData.patientClaim) {
                    details.push("Send patient payment link");
                    details.push("Change encounter status to IN PROGRESS");
                    details.push("Once fully paid, invoice will be sent via ECLIPSE (Patient Claim Interactive) and encounter marked as COMPLETED");
                }
            }
        } else {
            //wc, tac, adf, pip, 3rd party (can only be postpay)
            details.push("Send insurer invoice and payment link");
            details.push("Change encounter status to IN PROGRESS");
            details.push("Once fully paid, final invoice and receipt will be sent to insurer and encounter marked as COMPLETED");
        }

        return details;
    }

 /*    $: minDateOfInvoiceCustomDueDate = _getMinDateOfInvoiceCustomDueDate(
        claimDelayProps.claimDelayHours,
    ); */

    // HELPER FUNCTIONS
    /* const _getMinDateOfInvoiceCustomDueDate = (claimDelayHours) => {
        const now = new Date();
        const minDate = new Date(
            now.getTime() + claimDelayHours * 60 * 60 * 1000,
        );
        return minDate;
    }; */


  /*   const handleClaimDelayHoursChange = () => {
        if (!claimDelayProps.customDueDate) return;

        const customDueDateValid =
            new Date(claimDelayProps.customDueDate).getTime() >=
            new Date(minDateOfInvoiceCustomDueDate).getTime();

        if (!customDueDateValid)
            claimDelayProps.customDueDate = minDateOfInvoiceCustomDueDate;
    }; */
</script>

<div class="flex flex-col gap-y-4">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div on:click={() => sendInvoice = false } class={`option-item ${!sendInvoice ? `option-active` : ''}`}>
       <div class="flex flex-row gap-x-4 items-center">
            <i class="option-icon fa-solid fa-file"></i>Create Only
       </div> 
       <div class="option-details">
            <div class="details-item">
                <div class="details-item-indicator">
                    1
                </div>
                <div class="details-item-text">
                    Create invoice
                </div>
            </div>
       </div>
    </div>
    
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div  on:click={() => sendInvoice = true } class={`option-item ${sendInvoice ? `option-active` : ''}`}>
        <div class="flex flex-row gap-x-4 items-center">
            <i class="option-icon fa-solid fa-paper-plane"></i>Create & Send
        </div>
        <div class="option-details">
           {#each getDetails() as details, index}
                <div class="details-item">
                    <div class="details-item-indicator">
                        {index + 1}
                    </div>
                    <div class="details-item-text">
                        {details}
                    </div>
                </div>
            {/each}
        </div>
       <!--  <div class="flex flex-row gap-x-2 pt-4">
            <div on:click={() => sendWithDelay = false } class={`send-indicator-button ${sendWithDelay ? '' : 'indicator-active'}`}>
                Send now
            </div>
            <div on:click={() => sendWithDelay = true} class={`send-indicator-button ${sendWithDelay ?  'indicator-active' : ''}`}>
                Schedule delay
            </div>
        </div>
        {#if sendWithDelay}
            <PatientEncounterInvoiceClaimDelay
                bind:itemProps={claimDelayProps}
                {handleClaimDelayHoursChange}
            />
        {/if} -->
    </div>

    {#if latestInvoiceData.invoiceReason == 3 || latestInvoiceData.invoiceReason == 4}
        <InvoiceReasonDetails 
            encounterDetails={patientEncounterDetails}
            bind:reason={latestInvoiceData.invoiceReason} 
            bind:difference={latestInvoiceData.patpDifference}>
        </InvoiceReasonDetails>
    {/if}

    <!-- show due date on invoice only if postpay with gap, max available due date is scheduled date of encounter -->
    {#if latestInvoiceData.oopType == 1 && latestInvoiceData.actualGap > 0}
        <div class="flex flex-col gap-y-2">
            <p class="text-sm">Invoice Due Date</p>

            <DateInput
                bind:value={customDueDate}
                minDate={new Date()} 
                wrapperClass="input input-sm px-2 input-bordered w-60"
            />
        </div>
    {/if}

</div>

<style>
   .option-item {
        width: 100%;
        border-radius: 6px;
        background-color: #f5f5f5;
        padding:15px;
        display: flex;
        flex-direction: column;
        gap: 10px;
   }

   .send-indicator-button {
        background: white;
        border-radius: 10px;
        padding:5px;
        font-size:12px;
        border:1px solid #ddd;
        padding-left: 10px;
        padding-right: 10px;
   }

   .indicator-active {
        background: rgb(146 68 225);
        color: white;
        border:1px solid rgb(146 68 225);
   }

   .option-item:hover {
        cursor: pointer;
        border: 1px solid rgb(225, 68, 68);
   }

    .option-details {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .details-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
    }

    .details-item-indicator {
        font-size: 12px;
        width: 30px;
        height: 30px;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #d4d4d4;
    }

    .details-item-text {
        flex:1;
        display: flex;
        align-items: center;
        font-size: 12px;
    }

   .option-active {
        background-color: aliceblue;
        border: 1px solid rgb(146 68 225);
   }

   .option-active .option-icon {
        color: rgb(146 68 225);
   }

   .option-active .details-item-indicator {
        background-color: rgb(146 68 225);
        color: white;
   }
</style>
